export default __webpack_public_path__ + "static/media/msat-instr-yellow-vector.3664f058.svg";